module.exports = __webpack_public_path__ + "img/hand-index-thumb.3259bb8c.svg";